module.exports = __webpack_public_path__ + "iphone-landscape.svg?3a8527af4740979fb10f60d894aa4613";